import { Col } from 'reactstrap';
import ComponentCard from '../../layouts/containers/ComponentCard';
import NuevoProfesor from '../../components/profesores/NuevoProfesor';

const CrearProfesores = () => {
  return (
    <>
      <Col md="12">
        <ComponentCard title="Crear profesor" hasButton>
          <div className="mt-4">
            <NuevoProfesor />
          </div>
        </ComponentCard>
      </Col>
    </>
  );
};
export default CrearProfesores;
